<template>
  <div>
    <Navbar/>
    <h4>Asegurador</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idAsegurador" class="form-label">IdAsegurador</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAsegurador" name="idAsegurador" v-model="datoAsegurador.idAsegurador" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoAsegurador.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoAsegurador.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarAsegurador" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAsegurador" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdTarifaAseg</th>
          <th scope="col">IdTarifario</th>
          <th scope="col">IdAsegurador</th>
          <th scope="col">FechaReg</th>
          <th scope="col">Estado</th>
          <th scope="col">TarifarioDescripcion</th>
          <th scope="col">AseguradorNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="tarifaaseg in datosPaginados" :key="tarifaaseg.idTarifaAseg">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(tarifaaseg.idTarifaAseg)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(tarifaaseg.idTarifaAseg)" title="Editar">edit_square</i></td>
          <td>{{tarifaaseg.idTarifaAseg}}</td>
          <td>{{tarifaaseg.idTarifario}}</td>
          <td>{{tarifaaseg.idAsegurador}}</td>
          <td>{{getFormattedDate(tarifaaseg.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{tarifaaseg.estado}}</td>
          <td>{{tarifaaseg.tarifarioDescripcion}}</td>
          <td>{{tarifaaseg.aseguradorNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteAsegurador(tarifaaseg.idTarifaAseg)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idTarifaAseg" class="form-label">IdTarifaAseg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTarifaAseg" name="idTarifaAseg" v-model="datoTarifaAseg.idTarifaAseg" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idTarifario" class="form-label"> Tarifario</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idTarifario" name="idTarifario" v-model="datoTarifaAseg.idTarifario">
                      <option v-for="tarifario in tarifarios" :value="tarifario.idTarifario" :key="tarifario.idTarifario">
                        {{ tarifario.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idAsegurador" class="form-label">IdAsegurador</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAsegurador" name="idAsegurador" v-model="datoTarifaAseg.idAsegurador" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoTarifaAseg.fechaReg" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarTarifaAseg" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditTarifaAseg" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      aseguradors : [],
      datoAsegurador : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idAsegurador: '',
// Variables master
// Variables details
      tarifaasegs : [],
      datoTarifaAseg : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      tarifarios : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idAsegurador = this.$route.params.p_idasegurador
    this.abrirEditar(this.p_idAsegurador)
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'nombre'
        ,'tipo'
      ];
      const requiredFieldsText = [
        'nombre'
        ,'tipo'
      ];
      return validarForm(this.datoAsegurador, requiredFields, requiredFieldsText);
    },
    async guardarAsegurador(){
      if(this.validarForm() === 1){
        try {
          await api.post('/aseguradors', this.datoAsegurador)
          swal("Correcto!", "Asegurador creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAsegurador(){
      if(this.validarForm() === 1){
        try {
          await api.post('/aseguradors', this.datoAsegurador)
          swal("Correcto!", "Asegurador creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoAsegurador={}
      this.titulo   = 'Crear Asegurador'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idAsegurador){
      this.modalWindow = true
      if(idAsegurador != null){    
           api.get('/vwaseguradors/'+idAsegurador).then(resp=>{
          this.datoAsegurador = resp.data;
           });
      }
      this.titulo   = 'Editar Asegurador'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarAsegurador(){
      this.$router.push('/Asegurador')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.tarifaasegs.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwtarifaasegs/nombre/'+this.nombreBusqueda).then(response=>{
          this.tarifaasegs=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.tarifaasegs.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwtarifaasegs').then(response=>{
      this.tarifaasegs=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.tarifaasegs.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'nombre'
        ,'tipo'
      ];
      const requiredFieldsText = [
        'nombre'
        ,'tipo'
      ];
      return validarForm(this.datoAsegurador, requiredFields, requiredFieldsText);
    },
    async guardarTarifaAseg(){
      if(this.validarForm() === 1){
        try {
          this.datoTarifaAseg.idAsegurador = this.datoAsegurador.idAsegurador;
          await api.post('/tarifaasegs', this.datoTarifaAseg)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "TarifaAseg creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditTarifaAseg(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tarifaasegs', this.datoTarifaAseg)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "TarifaAseg creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoTarifaAseg={}
      this.titulo   = 'Crear Asegurador'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idTarifaAseg){
      this.modalWindow = true
      if(idTarifaAseg != null){    
           api.get('/vwtarifaasegs/'+idTarifaAseg).then(resp=>{
          this.datoTarifaAseg = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Asegurador'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idTarifaAseg){
      this.modalWindow = true
      if(idTarifaAseg != null){
        this.$router.push('/tarifaasegmd/'+idTarifaAseg)
      }
    },
    async deleteTarifaAseg (idTarifaAseg) {
      try{
        await api.delete('/tarifaasegs/'+idTarifaAseg)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchTarifarios() {
      fetch('http://localhost:8080/api/v1/tarifarios')
        .then(response => response.json())
        .then(data => {
          this.tarifarios = data;
        })
        .catch(error => {
          console.error('Error fetching tarifarios:', error);
        });
    },
    fetchAseguradors() {
      fetch('http://localhost:8080/api/v1/aseguradors')
        .then(response => response.json())
        .then(data => {
          this.aseguradors = data;
        })
        .catch(error => {
          console.error('Error fetching aseguradors:', error);
        });
    },
  },
}
</script>
